
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {FETCH_MY_LATEST_INVOICES} from '@/store/action-types'
import Moment from 'moment'
import {Invoice} from '@/model/Invoice'
import InvoiceDetailDialog from '@/components/InvoiceDetailDialog.vue'

@Component({
  components: {
    InvoiceDetailDialog
  }
})
export default class LatestInvoice extends Vue {
  @Action(FETCH_MY_LATEST_INVOICES) fetchLatestInvoice!: ({ (): Promise<Invoice> })

  private invoice: Invoice | null = null
  private showInvoiceDetailDialog: boolean = false

  get invoiceLabel(): string {
    if (this.invoice) {
      return Moment(this.invoice.periodStart)
        .locale('sk-sk')
        .format('MMMM YYYY')
    }

    return ''
  }

  closeInvoiceDetailDialog() {
    this.showInvoiceDetailDialog = false
  }

  onPaymentClick(): void {
    this.showInvoiceDetailDialog = true
  }

  async fetchData(): Promise<void> {
    this.invoice = await this.fetchLatestInvoice()
  }

  mounted(): void {
    this.fetchData()
  }
}
